import type * as Types from '../../types';

import gql from 'graphql-tag';
import type * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/client';
export type AddNewSemesterToStudentMutationVariables = Types.Exact<{
  studentId: Types.Scalars['Int'];
}>;


export type AddNewSemesterToStudentMutation = { addNewSemesterToStudent?: Types.Maybe<{ __typename?: 'MatchStudentSemester', id: number, hochschulsemester?: Types.Maybe<number>, fachsemester?: Types.Maybe<number>, zeitraum?: Types.Maybe<{ __typename?: 'Zeitraum', zeitraumNameKuerzel?: Types.Maybe<string> }> }> };


export const AddNewSemesterToStudentDocument = gql`
    mutation addNewSemesterToStudent($studentId: Int!) {
  addNewSemesterToStudent(studentId: $studentId) {
    id
    hochschulsemester
    fachsemester
    zeitraum {
      zeitraumNameKuerzel
    }
  }
}
    `;
export type AddNewSemesterToStudentMutationFn = ApolloReactCommon.MutationFunction<AddNewSemesterToStudentMutation, AddNewSemesterToStudentMutationVariables>;

/**
 * __useAddNewSemesterToStudentMutation__
 *
 * To run a mutation, you first call `useAddNewSemesterToStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewSemesterToStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewSemesterToStudentMutation, { data, loading, error }] = useAddNewSemesterToStudentMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useAddNewSemesterToStudentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddNewSemesterToStudentMutation, AddNewSemesterToStudentMutationVariables>) {
        return ApolloReactHooks.useMutation<AddNewSemesterToStudentMutation, AddNewSemesterToStudentMutationVariables>(AddNewSemesterToStudentDocument, baseOptions);
      }
export type AddNewSemesterToStudentMutationHookResult = ReturnType<typeof useAddNewSemesterToStudentMutation>;
export type AddNewSemesterToStudentMutationResult = ApolloReactCommon.MutationResult<AddNewSemesterToStudentMutation>;
export type AddNewSemesterToStudentMutationOptions = ApolloReactCommon.BaseMutationOptions<AddNewSemesterToStudentMutation, AddNewSemesterToStudentMutationVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
